import Link from 'next/link';
import styled from 'styled-components';

export const CustomLink = styled(Link)<{ textcolor: string }>`
  color: ${(props) => props.textcolor};
  &:hover {
    text-decoration: none;
  }
`;
